import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "../environments/environment";

@Injectable()
export class HnService {
  //endpoint = 'http://localhost:3000/instance/config/MN-0001';
  endpoint = `${environment.CONFIG_API_BASE}`;

  constructor(private http: HttpClient) {}

  getTopPosts() {
    return this.http.get(this.endpoint);
  }

  getPermissions() {
    console.log("permission method");
    return this.http.get(
      `${this.endpoint}/${"assets/json/mock/permission.json"}`
    );
  }
}
